import styled, { keyframes, css } from "styled-components";

const slideIn = keyframes`
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100px);
    opacity: 0;
  }
`;

const typeStyles = {
  AVISO: {
    icon: "📢",
    bgColor: "#fffbeb",
    borderColor: "#fde68a",
    titleColor: "#b45309",
  },
  PROMOCAO: {
    icon: "🔥",
    bgColor: "#fef2f2",
    borderColor: "#fecaca",
    titleColor: "#b91c1c",
  },
  ATUALIZACAO: {
    icon: "⚙️",
    bgColor: "#eff6ff",
    borderColor: "#bfdbfe",
    titleColor: "#1d4ed8",
  },
  NOTICIA: {
    icon: "📰",
    bgColor: "#f0fdf4",
    borderColor: "#bbf7d0",
    titleColor: "#15803d",
  },
};

// Container que vai segurar todas as mensagens
export const MessageContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column-reverse; /* Mensagens novas aparecem em cima */
  gap: 16px;
  width: min(380px, calc(100vw - 40px));
  max-height: calc(100vh - 40px);

  @media (max-width: 600px) {
    left: 10px;
    right: 10px;
    bottom: 10px;
    width: auto;
    max-width: none;
    max-height: calc(100vh - 20px);
    gap: 10px;
  }
`;

// O card da mensagem individual
export const MessageBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-height: 40vh;
  display: flex;
  flex-direction: column;

  &,
  & * {
    box-sizing: border-box;
  }
  background-color: ${(props) =>
    typeStyles[props.messageType]?.bgColor || typeStyles.AVISO.bgColor};
  border: 1px solid
    ${(props) =>
      typeStyles[props.messageType]?.borderColor ||
      typeStyles.AVISO.borderColor};
  border-left: 5px solid
    ${(props) =>
      typeStyles[props.messageType]?.borderColor ||
      typeStyles.AVISO.borderColor};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  animation: ${(props) => (props.isClosing ? slideOut : slideIn)} 0.5s ease
    forwards;

  @media (max-width: 600px) {
    max-height: 35vh;
    padding: 12px;
  }
`;

export const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  gap: 8px;
  word-break: break-word;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  font-size: 1.2rem;
  padding: 0;
  line-height: 1;
  &:hover {
    color: #334155;
  }
`;

export const MessageBody = styled.p`
  font-size: 0.9rem;
  color: #4b5563;
  margin: 0 0 16px 0;
  line-height: 1.5;
  word-break: break-word;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  @media (max-width: 600px) {
    font-size: 0.85rem;
  }
`;

export const MessageFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Link = styled.a`
  font-size: 0.875rem;
  font-weight: 600;
  color: #3b82f6;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const Timestamp = styled.span`
  font-size: 0.75rem;
  color: #6b7280;
`;

// Link detectado automaticamente dentro do texto da mensagem
export const TextLink = styled.a`
  color: #2563eb;
  text-decoration: underline;
  font-weight: 600;
  word-break: break-all;

  &:hover {
    color: #1d4ed8;
  }
`;
